import CentralApiService from "../centralApiServices";


class UserService extends CentralApiService {

    constructor() {
        super('/api/users')
    }

    signUp(userData){
        return this.post('/signUp', userData)
    }

    getAllUsers() {
        return this.get('/getUsers')
    }

    changePassword(userData){
        return this.put('/changePassword', userData)
    }

    getUserFromEmailAndHash(email, hash){
        let params = `?`
        params = `${params}&email=${email}`
        params = `${params}&hash=${hash}`
        return this.get(`/getUserFromHash${params}`)
    }

    redefinePassword(email, hash, userData){
        let params = `?`
        params = `${params}&email=${email}`
        params = `${params}&hash=${hash}`
        return this.put(`/redefinePassword${params}`, userData)
    }

    changeUserStatus(userData){
        return this.post(`/changeUserStatus`, userData)
    }

    update(userData){
        return this.put(`/update`, userData)
    }

    delete(user){
        return this.post(`/delete`, user)
    }

}

export default UserService